import { Region } from './region';

export type CountryScope = 'awards' | 'global';

export interface Country {
  countryId: number;
  countryCode: string;
  displayName: string;
  postalCodeRequired: boolean;
  region?: Region;
}

export function copyCountry(country: Country): Country {
  return {
    countryCode: country.countryCode,
    countryId: country.countryId,
    displayName: country.displayName,
    postalCodeRequired: country.postalCodeRequired,
    region: country.region
  }
}

export function blankCountry(): Country {
  return {
    countryId: 0,
    countryCode: '',
    displayName: '',
    postalCodeRequired: false,
    region: undefined,
  };
}
